import { render, staticRenderFns } from "./DivInfoCall.vue?vue&type=template&id=34b64a44&scoped=true&lang=pug&"
import script from "./DivInfoCall.vue?vue&type=script&lang=js&"
export * from "./DivInfoCall.vue?vue&type=script&lang=js&"
import style0 from "./DivInfoCall.vue?vue&type=style&index=0&id=34b64a44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b64a44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34b64a44')) {
      api.createRecord('34b64a44', component.options)
    } else {
      api.reload('34b64a44', component.options)
    }
    module.hot.accept("./DivInfoCall.vue?vue&type=template&id=34b64a44&scoped=true&lang=pug&", function () {
      api.rerender('34b64a44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/DivInfoCall.vue"
export default component.exports